(function () {
  function qs(el, sel) { return el.querySelector(sel); }
  function qsa(el, sel) { return Array.from(el.querySelectorAll(sel)); }

  function getBaseOptions(form, productJson) {
    // Best case: options[Color], options[Size], etc exist
    const optionMap = {};
    qsa(form, '[name^="options["], select[name^="options["]').forEach((el) => {
      if (el.type === 'radio' && !el.checked) return;
      optionMap[el.name] = el.value;
    });

    const byNames = productJson.options.map((optName) => optionMap[`options[${optName}]`] ?? null);

    // If we got real values, use them
    if (byNames.every(v => v !== null && v !== "")) return byNames;

    // Fallback: use current variant id (Pipeline updates input[name="id"])
    const idInput = qs(form, 'input[name="id"]');
    const currentId = idInput ? parseInt(idInput.value || "0", 10) : 0;
    const v = productJson.variants.find(x => x.id === currentId);
    if (v && v.options) return v.options;

    // Last resort
    return productJson.options.map(() => null);
  }

  function findVariant(productJson, optionsArr) {
    return productJson.variants.find(v =>
      v.options.every((val, idx) => val === optionsArr[idx])
    );
  }

  function initGrid(grid) {
    const productJsonEl = document.getElementById(grid.dataset.productJsonId);
    if (!productJsonEl) return;

    const productJson = JSON.parse(productJsonEl.textContent);
    const form = grid.closest('form[action*="/cart/add"]') || grid.closest('form');
    if (!form) return;

    const sizeIndex = parseInt(grid.dataset.sizeIndex, 10); // 1-based
    const noteEl = qs(grid, '.sqg-note');

    function setNote(msg) { if (noteEl) noteEl.textContent = msg || ''; }

    function updateVariantIds() {
      const base = getBaseOptions(form, productJson);

      qsa(grid, '[data-size-row]').forEach((row) => {
        const sizeVal = row.dataset.sizeValue;
        const options = base.slice();
        options[sizeIndex - 1] = sizeVal;

        const variant = findVariant(productJson, options);
        const input = qs(row, '.sqg-input');
        const buttons = qsa(row, '.sqg-btn');

        if (!variant || !variant.available) {
          row.classList.add('is-unavailable');
          input.dataset.variantId = '';
          input.value = 0;
          input.disabled = true;
          buttons.forEach(b => b.disabled = true);
          return;
        }

        row.classList.remove('is-unavailable');
        input.dataset.variantId = String(variant.id);
        input.disabled = false;
        buttons.forEach(b => b.disabled = false);
      });
    }

    // +/- buttons
    grid.addEventListener('click', (e) => {
      const btn = e.target.closest('.sqg-btn');
      if (!btn) return;

      const row = btn.closest('[data-size-row]');
      const input = qs(row, '.sqg-input');
      if (!input || input.disabled) return;

      const current = parseInt(input.value || '0', 10);
      const next = btn.dataset.action === 'inc' ? current + 1 : Math.max(0, current - 1);
      input.value = String(next);
    });

    // Keep synced when options change
    form.addEventListener('change', () => updateVariantIds());

    // Watch variant id changes (themes often update hidden input without firing change)
    const idInput = qs(form, 'input[name="id"]');
    if (idInput) {
      const mo = new MutationObserver(updateVariantIds);
      mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }

    // Intercept submit and multi-add
    form.addEventListener('submit', async (e) => {
      const items = [];
      qsa(grid, '.sqg-input').forEach((input) => {
        const qty = parseInt(input.value || '0', 10);
        const id = parseInt(input.dataset.variantId || '0', 10);
        if (qty > 0 && id) items.push({ id, quantity: qty });
      });

      if (items.length === 0) {
        e.preventDefault();
        setNote('Add quantities for at least one size.');
        return;
      }

      e.preventDefault();
      setNote('Adding…');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (!res.ok) throw new Error(await res.text());

        qsa(grid, '.sqg-input').forEach(i => i.value = 0);
        setNote('Added to cart.');
        window.location.href = '/cart';
      } catch (err) {
        console.error(err);
        setNote('Could not add to cart. Please try again.');
      }
    });

    updateVariantIds();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-size-qty-grid]').forEach(initGrid);
  });
})();

